import * as React from "react";
import {Fragment} from "react";
import {WaveLoading} from "react-loadingg";

export default class SFXLoadingComponent extends React.Component {

    render() {
        return <Fragment>
            {
                window.innerWidth < 575
                    ? <WaveLoading
                        style={this.props.style || {position: "inherit", margin: "auto"}}
                        color={this.props.color !== undefined ? this.props.color : "var(--riaOrange)"}
                        speed={this.props.speed !== undefined ? this.props.speed : "1"}
                        size={this.props.size !== undefined ? this.props.size : "large"}
                    />
                    : <WaveLoading
                        style={this.props.style || {position: "inherit", margin: "auto"}}
                        color={this.props.color !== undefined ? this.props.color : "var(--riaOrange)"}
                        speed={this.props.speed !== undefined ? this.props.speed : "1"}
                        size={this.props.size !== undefined ? this.props.size : "large"}
                    />
            }
            {
                this.props.message && <div className={"spinner_message"} style={{textAlign: "center"}}>
                    <br/>
                    {this.props.message}
                </div>
            }
        </Fragment>
    }
}